import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import {
  SecondaryButton,
  TertiaryButton,
} from '@grnhse/seedling/lib/birch/components/buttons';
import { withLocalePrefix } from 'shared/utils/translation';
import ApplicationHistoryFiltersGroup from 'talent_matching/talent_rediscovery/application_history_filters_group';
import CandidateFiltersGroup from 'talent_matching/talent_rediscovery/candidate_filters_group';
import JobDetailsFiltersGroup from 'talent_matching/talent_rediscovery/job_details_filters_group';
import AdvancedFiltersGroup from 'talent_matching/talent_rediscovery/advanced_filters_group';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown/item';
import type { SavedSearchItem } from 'talent_search/shared/types';
import Api from 'talent_search/lib/api';
import EditIcon from '@grnhse/seedling/lib/birch/icons/edit';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

type Props = {
  onClearAll: () => void;
  onLoadFilters?: () => void;
  onSaveFilters?: () => void;
  milestones: Item[];
  apiClient: Api | null;
  currencies: Item[];
  savedFilterSet: SavedSearchItem | null;
};

const RediscoveryFilterRow = ({
  onClearAll,
  onLoadFilters,
  onSaveFilters,
  milestones,
  apiClient,
  currencies,
  savedFilterSet,
}: Props) => {
  if (!apiClient) {
    return null;
  }

  return (
    <Stack spacing={0}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <ApplicationHistoryFiltersGroup
            milestones={milestones}
            apiClient={apiClient}
          />
          <CandidateFiltersGroup apiClient={apiClient} />
          <JobDetailsFiltersGroup apiClient={apiClient} />
          <AdvancedFiltersGroup apiClient={apiClient} currencies={currencies} />
          <TertiaryButton size="md" onClick={onClearAll}>
            {t('buttons.clear_all')}
          </TertiaryButton>
        </NoWrap>
        <NoWrap spacing={1} direction="row" alignItems="center">
          {savedFilterSet ? (
            <TertiaryButton
              size="md"
              onClick={onLoadFilters}
              icon={EditIcon}
              placement="right"
            >
              {savedFilterSet.label}
            </TertiaryButton>
          ) : (
            <TertiaryButton size="md" onClick={onLoadFilters}>
              {t('saved_filters.load')}
            </TertiaryButton>
          )}
          <SecondaryButton size="md" onClick={onSaveFilters}>
            {t('saved_filters.save_filters')}
          </SecondaryButton>
        </NoWrap>
      </Stack>
    </Stack>
  );
};

export default RediscoveryFilterRow;
